import { render } from "./CarouselControlls.vue?vue&type=template&id=365a5fe7&scoped=true&bindings={}"
import script from "./CarouselControlls.vue?vue&type=script&lang=ts"
export * from "./CarouselControlls.vue?vue&type=script&lang=ts"

import "./CarouselControlls.vue?vue&type=style&index=0&id=365a5fe7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-365a5fe7"

export default script